import { Price } from './price';
import { Sector } from './sector';

export interface FlightValidationRequest {
  searchId: string;
  sessionToken: string;
  optionId: number;
  upsellOptionId: number;
  userId: string;
  distanceRestriction: string;
  lowestLogicalFare: number;
}

export interface AirFareConditions {
  id: number;
  //  airReservationId?: number;
  airReservationsId?: number;
  sector: number;
  flight: string;
  cancellationAllowed: boolean;
  changesAllowed: boolean;
  noShow: boolean | number;
  changesAmount?: {
    currencyCode: string;
    fare: number;
    taxes: number;
  };
}

export enum AirValidationResultType {
  Available = 'Available',
  NotAvailable = 'NotAvailable',
  PriceDifferent = 'PriceDifference',
  ErrorServer = 'ErrorServer',
}

export interface FlightValidationResponse {
  tripOption: {
    sectors: Sector[];
    price: Price;
    provider: string;
    adultsFareAmount: number;
    childsFareAmount: number;
    infantsFareAmount: number;
    preferenceOrder: number;
    textFare: string;
    optionId: number;
  };
  result: AirValidationResultType;
  airFareConditions: AirFareConditions[];
  validateAvailableUntil: Date;
  validationId: string;
  isPreApproved?: boolean;
  breakRulesMessage?: string[];
}
